import React from 'react'
import ReactApexChart from 'react-apexcharts'
import {ApexOptions} from 'apexcharts'

interface ChartRendererProps {
  options: ApexOptions
  series: any // Accept various series formats (object[] for bar/line, number[] for pie)
  type: 'bar' | 'area' | 'line' | 'pie'
  height: number
  width?: string
  noDataText: string
}

export const ChartRenderer: React.FC<ChartRendererProps> = ({
  options,
  series,
  type,
  height,
  width = '100%',
  noDataText,
}) => {
  const isPie = type === 'pie'
  // For pie charts, ApexCharts expects series to be an array of numbers.
  // For other chart types, ensure objects with name & data.
  const hasValidStructure = isPie
    ? Array.isArray(series)
    : Array.isArray(series) && series.every((s: any) => s && s.name && Array.isArray(s.data))

  // If structure is invalid, fall back to showing a message
  if (!hasValidStructure) {
    return (
      <div className='text-center py-5'>
        <span className='text-muted'>{noDataText}</span>
      </div>
    )
  }

  // Use the original series if available, otherwise pass an empty array so that
  // ApexCharts can display the built-in `noData` state (grid lines + message)
  const safeSeries = series && (Array.isArray(series) ? series : [])

  try {
    return (
      <ReactApexChart
        options={options}
        series={safeSeries}
        type={type as any}
        height={height}
        width={width}
      />
    )
  } catch (error) {
    return (
      <div className='text-center py-5'>
        <span className='text-danger'>Chart rendering error</span>
      </div>
    )
  }
}
